<template>
  <div id="app-news">
    <div class="news-box">
      <div class="news-top">
        <h5>相关新闻</h5>
        <!-- <router-link :to="{name:'pubIndex',query:{cid :3 } }"  > -->
        <span @click="gotoNews">更多</span>
        <!-- </router-link> -->
      </div>
      <div class="news-bottom">
        <ul>
          <li v-for="(item,index) in newsList"
              :key="index"
              @click="gotoNewsDetails(item.id)">
            <!-- <router-link :to="{name:'pubDetails',query:{id :item.id } }"  > -->
            <i></i>
            {{item.news_title}}
            <!-- </router-link> -->
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    newsList: {

    }
  },
  data () {
    return {

      // newsList: [
      //   {
      //     id: 1,
      //     title: "湘西贫困学生重大眼病救助治疗"
      //   }
      // ]
    };
  },
  methods: {
    gotoNews () {
      this.$router.push({ path: "/pubIndex", query: { cid: 3 } });
      // sessionStorage.setItem('bread1','爱眼公益行')
      // sessionStorage.setItem("index", 3);
    },
    gotoNewsDetails (id) {
      this.$router.push({ path: "/pubDetails", query: { cid: 3, id: id } });
      // sessionStorage.setItem('bread1','爱眼公益行')
      // sessionStorage.setItem("index", 3);
    },
  },
  created () {
  }

};
</script>

<style lang="scss" scoped>
#app-news {
  width: 100%;
  border: solid 1px #eaeaea;
}
.news-box {
  .news-top {
    border-bottom: solid 1px #eaeaea;
    position: relative;
    padding: 20px 0;
    > h5 {
      font-size: 16px;
      color: #333333;
      padding-left: 18px;
    }
    // > a{
    // color: #333333;
    > span {
      cursor: pointer;
      font-size: 14px;
      color: #999999;
      position: absolute;
      right: 23px;
      top: 50%;
      transform: translateY(-50%);
    }
    // }
  }
  .news-bottom {
    padding: 17px 16px 21px 22px;
    > ul {
      > li {
        cursor: pointer;
        list-style: none;
        padding-left: 6px;
        font-size: 16px;
        color: #333333;
        overflow: hidden; /*超出部分隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /*超出部分省略号显示*/
        margin-bottom: 15px;
        position: relative;
        &:last-child {
          margin-bottom: 0;
        }
        // >a{
        // color:#333;
        > i {
          width: 3px;
          height: 3px;
          border-radius: 50%;
          background-color: #333;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }

      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Project_details/details_news.vue